import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

import { INotificationParams } from '../interfaces/interfaces';
import { NotificationComponent } from '../components/shared/notification/main';

@Injectable()
export class NotificationService {

	constructor(private snackBar: MatSnackBar) { }

	public generateNotifcation(params: INotificationParams): void {

		if (!params) {
			return;
		}

		this._capitalizeMessage(params);

		this.snackBar.openFromComponent(NotificationComponent, {
			duration: 10000,
			panelClass: 'bk-notification',
			data: params
		})
	}

	/**
	 * Opens a notification with no duration. The caller dismisses it.
	 */
	public openUntimed(params: INotificationParams): MatSnackBarRef<NotificationComponent> {
		this._capitalizeMessage(params);

		return this.snackBar.openFromComponent(NotificationComponent, {
			panelClass: 'bk-notification',
			data: params
		});
	}

	/**
	 * Capitalizes the first letter of the notification message.
	 */
	private _capitalizeMessage(params: INotificationParams): void {
		if (!params || !params.message) {
			return;
		}

		params.message = params.message.charAt(0).toUpperCase() + params.message.substr(1);
	}
}
